/**
 * Enumeration of programmatic error codes for invalid search queries.
 */
export enum QueryValidationReason {
  /**
   * Invalid search form type (should be set to either Airports or Activities)
   */
  INVALID_SEARCH_TYPE = 'INVALID_SEARCH_TYPE',

  /**
   * Missing base parameters for running a search. All searches require either a center point
   * and radius, or query text.
   */
  MISSING_BASE_PARAMS = 'MISSING_BASE_PARAMS',

  /**
   * Radius is required for performing a radius search
   */
  MISSING_RADIUS = 'MISSING_RADIUS',

  /**
   * Radius is not within bounds
   */
  INVALID_RADIUS = 'INVALID_RADIUS',

  /**
   * Minimum runway length must be greater than zero
   */
  MIN_RUNWAY_LENGTH = 'MIN_RUNWAY_LENGTH'
}


/**
 * Validation result model for an airports/destinations search query.
 */
export class QueryValidationResult {
  /**
   * Indicates whether the query is valid. If the query is valid, other properties in this class may not be populated.
   */
  valid: boolean;

  /**
   * Programmatic error code that indicates why the query is not valid. For invalid queries, this property will always
   * be populated (unlike message, which is only populated if it's a user error).
   */
  reason?: QueryValidationReason;

  /**
   * User-friendly message that explains why the query is not valid. This property is only populated if the query is
   * invalid due to an invalid user input (as opposed to programming error).
   */
  message?: string;
}
